// @flow
import _ from 'lodash';
import moment from 'moment';

import ApiManager from './ApiManager';

// -- constants
import APIEndpoints from '../constants/APIEndpoints';

// -- entities
import ApiError from '../entities/ApiError';
import ApiObject from '../entities/ApiObject';
import RestaurantsGroup from '../entities/restaurantsGroup/RestaurantsGroup';

class ApiRestaurantsGroup {
  static getRestaurantsGroupWithDomain(
    restaurantsGroupId: string,
    proDomain,
    loadChildren: boolean,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP.replace(
      ':restaurantsGroupId',
      restaurantsGroupId
    );

    const requestOptions = {
      endpoint,
      query: {
        loadChildren,
      },
      headers: {
        'pro-domain-id': proDomain.id,
      },
      success: (json: Object) => {
        console.log('[GET_RESTAURANT_GROUPS] SUCCESS: ', json);

        const restaurantsGroup: RestaurantsGroup = new RestaurantsGroup();
        restaurantsGroup.fromJson(json);

        success(restaurantsGroup);
      },
      failure: (apiError: ApiError) => {
        console.log('[GET_RESTAURANT_GROUPS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  static getRestaurantsGroup(
    restaurantsGroupId: string,
    loadChildren: boolean,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP.replace(
      ':restaurantsGroupId',
      restaurantsGroupId
    );

    const requestOptions = {
      endpoint,
      query: {
        loadChildren,
      },
      success: (json: Object) => {
        console.log('[GET_RESTAURANT_GROUPS] SUCCESS: ', json);

        const restaurantsGroup: RestaurantsGroup = new RestaurantsGroup();
        restaurantsGroup.fromJson(json);

        success(restaurantsGroup);
      },
      failure: (apiError: ApiError) => {
        console.log('[GET_RESTAURANT_GROUPS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  /**
   * Create a new restaurantsGroup.
   */
  static postRestaurantsGroup(
    restaurantsGroup: RestaurantsGroup,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUPS;

    const requestOptions = {
      endpoint,
      data: restaurantsGroup,
      success: (json: Object) => {
        console.log('[POST_RESTAURANT_GROUPS] SUCCESS: ', json);

        const restaurantsGroup: RestaurantsGroup = new RestaurantsGroup();
        restaurantsGroup.fromJson(json);

        success(restaurantsGroup);
      },
      failure: (apiError: ApiError) => {
        console.log('[POST_RESTAURANT_GROUPS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.post(requestOptions);
  }

  /**
   * Update the restaurantsGroup.
   */
  static putRestaurantsGroup(
    restaurantsGroup: RestaurantsGroup,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP.replace(
      ':restaurantsGroupId',
      restaurantsGroup.id
    );

    const requestOptions = {
      endpoint,
      data: restaurantsGroup,
      success: (json: Object) => {
        console.log('[PUT_RESTAURANT_GROUPS] SUCCESS: ', json);

        const restaurantsGroup: RestaurantsGroup = new RestaurantsGroup();
        restaurantsGroup.fromJson(json);

        success(restaurantsGroup);
      },
      failure: (apiError: ApiError) => {
        console.log('[PUT_RESTAURANT_GROUPS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.put(requestOptions);
  }

  static getOrderStatistics(
    restaurantsGroupId: string,
    fromTime: number,
    toTime: number,
    modes,
    sourcesList,
    paymentMethods,
    restaurantsIds,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP_ORDER_STATISTICS.replace(
      '{restaurantsGroupId}',
      restaurantsGroupId
    );

    const requestOptions = {
      endpoint,
      data: {
        fromTime,
        toTime,
        modes,
        sourcesList,
        //paymentMethods,
        restaurantsIds,
      },
      success: (json: Object) => {
        console.log('[RESTAURANTS_GROUPS_GET_ORDER_STATISTICS] SUCCESS: ', json);

        // -- create the payment statistics object.
        const data: ApiObject = new ApiObject();
        data.fromJson(json);

        success(data);
      },
      failure: (apiError: ApiError) => {
        console.log('[RESTAURANTS_GROUPS_GET_ORDER_STATISTICS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.post(requestOptions);
  }

  static getApiConsumers(restaurantsGroupId, query, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP_API_CONSUMERS.replace(
      '{restaurantsGroupId}',
      restaurantsGroupId
    );

    const requestOptions = {
      endpoint,
      query,
      success: (json: Object) => {
        console.log('[RESTAURANTS_GROUPS_GET_API_CONSUMERS] SUCCESS: ', json);

        // -- create the payment statistics object.
        const data: ApiObject = new ApiObject();
        data.fromJson(json);

        success(data);
      },
      failure: (apiError: ApiError) => {
        console.log('[RESTAURANTS_GROUPS_GET_API_CONSUMERS] FAILURE: ', apiError);
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }
}

export default ApiRestaurantsGroup;
